
import React from 'react';
import Layout from '@/components/layout/Layout';
import FinanceSpendAnalysis from '@/components/finance/FinanceSpendAnalysis';

const FinanceSpendAnalysisPage = () => {
  return (
    <Layout>
      <div className="w-full max-w-full py-8">
        <h1 className="text-3xl font-bold mb-8">Spend Analysis</h1>
        <FinanceSpendAnalysis />
      </div>
    </Layout>
  );
};

export default FinanceSpendAnalysisPage;
